import {styled} from '@mui/material/styles';
import {mergeClasses} from 'minimal-shared/utils';
import {CSSProperties, forwardRef} from 'react';
import SimpleBar from 'simplebar-react';

import {scrollbarClasses} from './classes';
import type {ScrollbarProps} from './types';

// ----------------------------------------------------------------------

// eslint-disable-next-line react/display-name
export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>((props, ref) => {
  const {slotProps, children, fillContent = true, className, sx, ...other} = props;

  return (
    <ScrollbarRoot
      scrollableNodeProps={{ref}}
      clickOnTrack={false}
      fillContent={fillContent}
      className={mergeClasses([scrollbarClasses.root, className])}
      sx={[
        {
          '& .simplebar-wrapper': slotProps?.wrapperSx as CSSProperties,
          '& .simplebar-content-wrapper': slotProps?.contentWrapperSx as CSSProperties,
          '& .simplebar-content': slotProps?.contentSx as CSSProperties,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </ScrollbarRoot>
  );
});

// ----------------------------------------------------------------------

const ScrollbarRoot = styled(SimpleBar, {
  shouldForwardProp: (prop: string) => !['fillContent', 'sx'].includes(prop),
})<Pick<ScrollbarProps, 'fillContent'>>(({fillContent}) => ({
  minWidth: 0,
  minHeight: 0,
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  ...(fillContent && {
    '& .simplebar-content': {
      display: 'flex',
      flex: '1 1 auto',
      minHeight: '100%',
      flexDirection: 'column',
    },
  }),
}));
